import React from 'react';
import resourceName from 'core/common/resourceName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import ResourceItem from 'interfaces/resource';

const img = (
  <svg
    width="25"
    height="17"
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="17"
      height="12"
      rx="3"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M8.9 4.9A3.3 3.3 0 1 1 5.8 3.9"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      fill="none"
    />
    <path d="M5 3.2l1.3.4-.6 1.4z" fill="currentColor" />
    <rect
      x="12.8"
      y="3.5"
      width="3.7"
      height="1.2"
      rx="0.6"
      fill="currentColor"
    />
    <rect
      x="12.8"
      y="6.4"
      width="3.7"
      height="1.2"
      rx="0.6"
      fill="currentColor"
    />
    <rect
      x="12.8"
      y="9.3"
      width="3.7"
      height="1.2"
      rx="0.6"
      fill="currentColor"
    />
  </svg>
);

const TriggerClawbackResource: ResourceItem = {
  name: resourceName.triggerClawback,
  identifier: PrivateRouteConst.TRIGGER_CLAWBACK_SCREEN,
  list: `${resourceName.triggerClawback}`,
  meta: {
    label: 'Trigger Clawback',
    icon: img,
    parent: resourceName.cancellationManagement,
  },
};

export default TriggerClawbackResource;
